import { Icon } from '@acast/decibel';
import {
  CheckSolidGlyph,
  ExclamationSolidGlyph,
  MusicSolidGlyph,
  PlusLightGlyph,
  TimesLightGlyph,
} from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import getDurationLabel from 'shared/helpers/get-duration-label';
import HiddenFileSelectButton from './hidden-file-select-button';

function getStatusIcon(status) {
  switch (status) {
    case 'info':
      return PlusLightGlyph;
    case 'error':
      return TimesLightGlyph;
    case 'warning':
      return ExclamationSolidGlyph;
    default:
      return CheckSolidGlyph;
  }
}

export const AudioPane = ({ type = 'success', fileName, duration, replace, retry }) => (
  <div className={`audio-pane audio-pane--${type}`}>
    <div className="audio-pane__icon">
      <Icon glyph={MusicSolidGlyph} size="1em" className="audio-pane__icon-glyph" />
      <Icon glyph={getStatusIcon(type)} size="1em" className="audio-pane__icon-status" />
    </div>
    <span className="audio-pane__label">{fileName}</span>
    <div className="audio-pane__misc">
      {getDurationLabel(duration)}
      {replace && (
        <span>
          {' '}
          &#9642; <HiddenFileSelectButton onFileSelected={replace} />
        </span>
      )}
      {retry && (
        <span>
          {' '}
          &#9642;{' '}
          <button className="audio-pane__retry-button" onClick={retry}>
            Retry
          </button>
        </span>
      )}
    </div>
  </div>
);

AudioPane.propTypes = {
  type: T.oneOf(['success', 'info', 'warning', 'error']),
  fileName: T.string,
  duration: T.number,
  replace: T.func,
  retry: T.func,
};

export default AudioPane;
